/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import './page/dvsn-form-builder-submission-list';
import './page/dvsn-form-builder-submission-detail';

import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

const { Module } = Shopware;

Module.register('dvsn-form-builder-submission', {
    type: 'plugin',
    name: 'dvsn-form-builder-submission.general.name',
    title: 'dvsn-form-builder-submission.general.menu-item-name',
    description: 'dvsn-form-builder-submission.general.menu-item-description',
    color: '#FF68B4',
    icon: 'regular-cog',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },

    routes: {
        list: {
            component: 'dvsn-form-builder-submission-list',
            path: 'list'
        },
        detail: {
            component: 'dvsn-form-builder-submission-detail',
            path: 'detail/:id',
            meta: {
                parentPath: 'dvsn.form.builder.submission.list'
            }
        },
    },
});
